import $ from 'jquery'
import { register } from '@shopify/theme-sections'
import '../../styles/sections/index-buyers-guide.scss'


export default register(`index-buyers-guide`, {
  onLoad() {
    $(`.buyers-guide__fcm`).each(function() {
      $(this).find(`.slick-slider`).slick()
    })
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

